/**
 * Interface representing a ticket approval in the TicketEasy system
 */
export interface TicketApproval {
  /**
   * The name of the approver
   */
  approver: string;
  
  /**
   * The email of the approver
   */
  approverEmail: string;
  
  /**
   * The status of the approval
   */
  status: string;
  
  /**
   * Indicates if the ticket is approved
   */
  isApproved: boolean;
  
  /**
   * Indicates if the ticket is rejected
   */
  isRejected: boolean;
  
  /**
   * The date when the ticket was approved (if approved)
   */
  approvedDate?: string;
  
  /**
   * The date when the ticket was rejected (if rejected)
   */
  rejectDate?: string;
  
  /**
   * Comments related to the approval decision
   */
  comments: string;
  
  /**
   * The date when the approval was requested
   */
  requestedDate: string;
}

export function DefaultTicketApproval(): TicketApproval {
  return {
    approver: "",
    approverEmail: "",
    status: "Pending",
    isApproved: false,
    isRejected: false,
    approvedDate: "",
    rejectDate: "",
    comments: "",
    requestedDate: "",
  };
}